
const TEST_QUESTION_TYPES = {
    NUMBER_INPUT: 'number_input',
    TEXT_INPUT: 'text_input',
    SINGLE_CHOICE: 'single_choice',
    MULTIPLE_CHOICE: 'multiple_choice',
};

export default TEST_QUESTION_TYPES;
